import React, { Component } from 'react';
import * as API from './api.js';
import Loader from './icons/loader.svg';
import { Link } from 'react-router-dom';
import dateFormat from 'dateformat';
import RenewSubscription from './subscription/Reusable/RenewSubscription.js';
import AppConstants from './AppConstants.js';
import TableViewPagination from './ReusableComponents/TableView/TableViewPagination.js';

const PAGE_SIZE = 15
export default class Invoices extends Component {
    state = {
        user: {},
        type: "",

        org: {},
        loading: true,
        pageNumber: 1,
        totalCount: 0,
        pdfUrl: "",
        invoiceType: "Paid"
    }


    // pdftoBlob (pdfString){

    //   const url = `data:application/pdf;base64,${pdfString}`
    //   this.setState((prev)=>({...prev,pdfUrl:url}));

    //   return () => URL.revokeObjectURL(url);
    // }

    pdfToBlob(pdfBase64) {
        // Convert base64 to binary
        const byteCharacters = atob(pdfBase64);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        // Create a Blob and object URL
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        // Open in a new tab
        window.open(blobUrl, '_blank');

        // Optional: Cleanup after few minutes (if desired)
        setTimeout(() => URL.revokeObjectURL(blobUrl), 5 * 60 * 1000); // 5 min
    }

    previewInvoicePdf(InvoiceId) {

        API.getMyInvoicesPreview(InvoiceId).then(res => {
            let { invoiceBlob } = res

            return this.pdfToBlob(invoiceBlob)
        }).catch(e => {
            alert("Failed to preview your invoices. Try again later. Error: " + e)
        })
    }

    getInvoices() {
        API.getMyInvoices(PAGE_SIZE, this.state.pageNumber, this.state.invoiceType).then(res => {
            let { invoices, totalCount, zohoInvoice } = res
            // this.pdftoBlob(invoiceBlob)
            this.setState({
                invoices,
                totalCount,
                zohoInvoice
            }, () => {
                this.setState({
                    loading: false
                })
            })
        }).catch(e => {
            alert("Failed to get your invoices. Try again later. Error: " + e)
        })
    }

    componentDidMount() {
        this.getInvoices()
    }

    componentWillMount() {
        document.title = "My Invoices - AeroGCS";
        if (this.props) {
            let { user, type, invoice } = this.props;
            if (!user.sub) {
                user.sub = {
                    "plan": "aeromegh_plan_free"
                }
            }
            this.setState((state) => ({
                ...state,
                user,
                type,
            }), () => {
            })

            if (invoice) {
                this.previewInvoicePdf(invoice)
            }
        } else {
            API.getUserType().then(([blah, type, user]) => {
                if (!user.sub) {
                    user.sub = {
                        "plan": "aeromegh_plan_free"
                    }
                }
                this.setState((state) => ({
                    ...state,
                    user,
                    type
                }), () => {
                })
            }, (e) => {
                window.location.replace("/login");
            })
        }
    }

    render() {
        let { user, type, model } = this.state
        return (
            user.username ? <div className="wrapper">
                <div className='setting-containt' >
                    {this.state.loading ?
                        <div style={{ height: "50vh", width: "65vw", display: "flex", textAlign: "center" }}>
                            <img src={Loader} style={{ height: "30vh", width: "100vw", margin: "auto" }} />
                        </div>
                        : <div>



                            <div style={{ overflow: "auto", height: 'calc(100% - 80px)', position: 'absolute', width: '93%', marginTop: '20px' }}>

                                {/* <div style={{ marginLeft: "auto", paddingBottom:"7px", width: "fit-content", display: 'flex', gap: '20px' }}>
                                    <div style={{ marginLeft: "auto", width: "fit-content", display: 'flex', gap: '20px' }}>
                                        <div onClick={() => {
                                            if (this.state.invoiceType == 'Paid') return;
                                            this.setState((prev) => {
                                                return { ...prev, invoiceType: 'Paid' }
                                            }, () => {
                                                this.getInvoices()
                                            })
                                        }} className="addcustomer-button-empty-dashboard"
                                            style={{ padding: "10px 23px 10px 23px", cursor: this.state.invoiceType == 'Paid' ? 'not-allowed' : 'pointer' }}> View Paid
                                        </div>
                                    </div>

                                    <div style={{ marginLeft: "auto", width: "fit-content", display: 'flex', gap: '20px' }}>
                                        <div onClick={() => {
                                            if (this.state.invoiceType == 'Unpaid') return;
                                            this.setState((prev) => {
                                                return { ...prev, invoiceType: 'Unpaid', currentPage: 1 }
                                            }, () => {
                                                this.getInvoices()
                                            })
                                        }} className="addcustomer-button-empty-dashboard"
                                            style={{ padding: "10px 23px 10px 23px", cursor: this.state.invoiceType == 'Unpaid' ? 'not-allowed' : 'pointer' }}> View Unpaid
                                        </div>
                                    </div>
                                </div> */}


                                <table className="customers-table" style={{ marginTop: "0px" }}>
                                    <col style={{ width: '15%' }} />
                                    <col style={{ width: '35%' }} />
                                    <col style={{ width: '20%' }} />
                                    <col style={{ width: '15%' }} />

                                    <tr className="customers-table-header-row" style={{ background: "#E1EDFF", top: "-1px" }}>
                                        <th>Invoice Number</th>
                                        {/* <th>Product</th> */}
                                        <th>Date & Time</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                    </tr>
                                    {this.state.zohoInvoice.length === 0 ?
                                        <tr className="customers-table-data-row" align="center" style={{ height: "45px" }}>
                                            <td colspan="100%">No invoices available</td>
                                        </tr> :
                                        this.state.zohoInvoice.map((invoice, i) => <tr className="customers-table-data-row">
                                            <td >
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault(); // prevent page jump
                                                        this.previewInvoicePdf(invoice.invoice_id);
                                                    }}
                                                    style={{ color: "#707683", cursor: "pointer" }}
                                                >
                                                    {invoice.invoice_number}
                                                </a>
                                            </td>
                                            <td>{dateFormat(new Date(invoice.created_time), 'dd mmm yyyy hh:MM:ss TT')}</td>
                                            <td>{invoice?.currency_symbol === "Rs." ? "₹" : invoice?.currency_symbol === "usd" ? "$" : "₹"}{invoice.total}</td>

                                            <td>
                                                <div
                                                    style={{
                                                        textTransform: 'capitalize',
                                                        color: invoice.status === 'paid' ? 'green' : 'red',
                                                        display: 'flex',
                                                        // justifyContent: 'space-between',
                                                        alignItems: 'center'
                                                    }}
                                                >
                                                    {/* Show formatted status */}
                                                    {invoice.status === 'due'
                                                        ? 'Pending'
                                                        : invoice.status === 'partially_paid'
                                                            ? 'Partially Paid'
                                                            : invoice.status}

                                                    {/* Conditionally show RenewSubscription component for due */}
                                                    {invoice.status === 'due' && (
                                                        <RenewSubscription data={invoice} user={this.state.user} />
                                                    )}

                                                    {/* Conditionally render "Buy Now" link if not paid */}
                                                    {invoice.status !== 'paid' && invoice.invoice_url && (
                                                        <a
                                                            href={invoice.invoice_url}
                                                            style={{ marginLeft: '1rem', textDecoration: 'underline' }}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            Buy Now
                                                        </a>
                                                    )}
                                                </div>
                                            </td>

                                        </tr>)}
                                </table>
                                <TableViewPagination
                                                                    currentPage={Number(this.state.pageNumber)}
                                                                    totalCount={this.state.totalCount || 0}
                                                                    pageSize={PAGE_SIZE}
                                                                    padding="10px 5px"
                                                                    onPageChange={(page) => {
                                                                        this.setState({ pageNumber: page }, () => { this.getInvoices() })
                                                                    }}
                                                                />
                            </div>
                        </div>
                    }</div>
            </div > : <div />
        );
    }
}